import React from 'react';
import { Navigate } from 'react-router-dom';
import { NotFoundPage, AttendancePage, ShiftDashboardPage } from '@/pages';
import { RouteConfig } from '@/types';
import { APP_CONFIG } from '@/config/app';
import { useAuth } from '@/contexts/AuthContext';
import { canAccessShiftDashboard } from '@/utils/access';

// Blocks direct URL access for anyone the sidebar hides the menu from.
const RequireAttendanceDashboard: React.FC<{
  children: React.ReactElement;
}> = ({ children }) => {
  const { user, isLoading } = useAuth();
  if (isLoading) return null;
  if (!canAccessShiftDashboard(user)) {
    return <Navigate to={APP_CONFIG.homeRoute} replace />;
  }
  return children;
};

export const DASHBOARD_ROUTE: RouteConfig = {
  path: APP_CONFIG.homeRoute,
  element: <AttendancePage />,
  title: 'Attendance',
  icon: 'attendance',
};

export const routes: RouteConfig[] = [
  DASHBOARD_ROUTE,
  {
    path: '/shift-dashboard',
    element: (
      <RequireAttendanceDashboard>
        <ShiftDashboardPage />
      </RequireAttendanceDashboard>
    ),
    title: 'Dashboard',
    icon: 'dashboard',
  },
  {
    path: '/settings',
    element: (
      <div className="p-6">
        <h1 className="text-2xl font-semibold text-gray-900 mb-2">Settings</h1>
        <p className="text-sm text-gray-500">Coming Soon .....</p>
      </div>
    ),
    title: 'Settings',
    icon: 'settings',
  },
  {
    path: '/support',
    element: (
      <div className="p-6">
        <h1 className="text-2xl font-semibold text-gray-900 mb-2">Support</h1>
        <p className="text-sm text-gray-500">Coming Soon ......</p>
      </div>
    ),
    title: 'Support',
    icon: 'help',
  },
  {
    path: '/',
    element: <Navigate to={APP_CONFIG.homeRoute} replace />,
    title: 'Home',
  },
  {
    path: '*',
    element: <NotFoundPage />,
    title: 'Page Not Found',
  },
];

export const getPageTitle = (pathname: string): string => {
  const route = routes.find((route) => route.path === pathname);
  return route?.title || APP_CONFIG.name;
};
